import React from 'react';
import { useState } from 'react';
const ImageCarousel = ({ images, altText, imageStyle, slideDuration = 500, }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isHovering, setIsHovering] = useState(false);
    if (!images || images.length === 0) {
        return (React.createElement("div", { style: {
                position: 'relative',
                width: '100%',
                border: '1px solid #ccc',
                borderRadius: 4,
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: 200, // Or use aspectRatio logic
                backgroundColor: '#f0f0f0',
                color: '#888',
            } }, "No images available"));
    }
    const hasMultipleImages = images.length > 1;
    const goToPrevious = (e) => {
        e.stopPropagation();
        setCurrentIndex((prevIndex) => prevIndex === 0 ? images.length - 1 : prevIndex - 1);
    };
    const goToNext = (e) => {
        e.stopPropagation();
        setCurrentIndex((prevIndex) => prevIndex === images.length - 1 ? 0 : prevIndex + 1);
    };
    // --- Base Button Styles ---
    const baseButtonStyle = {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 10,
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        color: 'white',
        border: 'none',
        borderRadius: '50%',
        width: '40px',
        height: '40px',
        fontSize: '20px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: isHovering && hasMultipleImages ? 1 : 0,
        transition: 'opacity 0.2s ease-in-out',
        userSelect: 'none',
    };
    return (React.createElement("div", { style: {
            position: 'relative',
            width: '100%',
            overflow: 'hidden',
            borderRadius: 4,
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            cursor: hasMultipleImages ? 'pointer' : 'default',
        }, onMouseEnter: () => setIsHovering(true), onMouseLeave: () => setIsHovering(false) },
        React.createElement("div", { style: {
                display: 'flex',
                transition: `transform ${slideDuration}ms ease-in-out`,
                transform: `translateX(-${currentIndex * 100}%)`,
            } }, images.map((src, index) => (React.createElement("img", { key: index, src: src, alt: `${altText} - Slide ${index + 1}`, style: {
                width: '100%',
                flexShrink: 0,
                display: 'block',
                aspectRatio: '16 / 9',
                objectFit: 'cover',
                backgroundColor: '#eee',
                ...imageStyle,
            } })))),
        hasMultipleImages && (React.createElement("button", { "aria-label": "Previous Image", onClick: goToPrevious, style: {
                ...baseButtonStyle,
                left: '10px',
            } }, "\u2039 ")),
        hasMultipleImages && (React.createElement("button", { "aria-label": "Next Image", onClick: goToNext, style: {
                ...baseButtonStyle,
                right: '10px',
            } }, "\u203A "))));
};
export default ImageCarousel;
//# sourceMappingURL=ImageCarousel.js.map